import { render, staticRenderFns } from "./ClientReport.vue?vue&type=template&id=73f3f61f&"
import script from "./ClientReport.js?vue&type=script&lang=js&"
export * from "./ClientReport.js?vue&type=script&lang=js&"
import style0 from "./ClientReport.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports